// @flow

// Vendors
import React, { useState } from 'react';

// Components
import { ProjectsCategoryGridItem } from '.';
import { LoadMore } from '../../components';

// Types
type Props = {
  categories: Array<{
    url: String,
    slug: String,
    title: String,
    thumbnail: {
      src: String,
      alt: String
    }
  }>,
  setFilter: Function,
  itemHoverText: string,
  loadMoreLabel: string
};

const ProjectsCategoryGrid = ({
  categories,
  setFilter,
  itemHoverText,
  loadMoreLabel
}: Props) => {
  const initialLimit = 8;
  const [showAll, setShowAll] = useState(false);
  const filteredCategories = !showAll
    ? categories.slice(0, initialLimit)
    : categories;

  return (
    <>
      <section
        className={`section section--sm u--padding-${
          showAll || categories.length < initialLimit ? 'top-0' : '0'
        }`}
      >
        <div className="container">
          <div className="category-grid grid grid--gutter-vertical">
            {filteredCategories &&
              filteredCategories.map(({ id, ...category }) => (
                <ProjectsCategoryGridItem
                  key={id}
                  category={category}
                  setFilter={setFilter}
                  hoverText={itemHoverText}
                />
              ))}
          </div>
        </div>
      </section>

      {filteredCategories < categories && (
        <LoadMore label={loadMoreLabel} onClick={() => setShowAll(true)} />
      )}
    </>
  );
};

ProjectsCategoryGrid.defaultProps = {
  itemHoverText: 'View Projects',
  loadMoreLabel: 'Show All Categories'
};

export default ProjectsCategoryGrid;
